import { useQuery } from '@tanstack/react-query';
import { apiRoutes } from '../../config/api/apiRoutes';
import axios from '../../libraries/axios/axios';
import { queryKeys } from '../keys';
import { VatRate } from '../../domain/VatRate';

export const useGetVatRatesQuery = () => {
  const fetchVatRates = async (): Promise<VatRate[]> => {
    const { data } = await axios.get(apiRoutes.vatRates.public);
    return data;
  };

  return useQuery({
    queryKey: queryKeys.vatRates.public,
    queryFn: () => fetchVatRates(),
    initialData: [],
  });
};
